import { render, staticRenderFns } from "./pub_easy_multi.vue?vue&type=template&id=6f24d845&scoped=true&"
import script from "./pub_easy_multi.vue?vue&type=script&lang=js&"
export * from "./pub_easy_multi.vue?vue&type=script&lang=js&"
import style0 from "./pub_easy_multi.vue?vue&type=style&index=0&id=6f24d845&scoped=true&lang=less&"
import style1 from "./pub_easy_multi.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f24d845",
  null
  
)

export default component.exports